import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=6fc3c925&scoped=true"
import script from "./WebFooter.vue?vue&type=script&lang=js"
export * from "./WebFooter.vue?vue&type=script&lang=js"
import style0 from "./WebFooter.vue?vue&type=style&index=0&id=6fc3c925&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3c925",
  null
  
)

export default component.exports